import { render, staticRenderFns } from "./WatchView.vue?vue&type=template&id=74639abe&scoped=true"
import script from "./WatchView.vue?vue&type=script&lang=js"
export * from "./WatchView.vue?vue&type=script&lang=js"
import style0 from "./WatchView.vue?vue&type=style&index=0&id=74639abe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74639abe",
  null
  
)

export default component.exports